import {
  Box,
  Button,
  Divider,
  IconButton,
  InputAdornment,
  Stack,
  TextField,
  Typography
} from '@mui/material';
import { Icon } from '@iconify/react';
import { AuthForm } from 'hooks/useAuthForm';
import IdentifierField from './IdentifierField';
import SubmitError from './SubmitError';
import YandexLoginButton from './YandexLoginButton';

export default function LoginForm({ auth }: { auth: AuthForm }) {
  const { form, ui, loading, submitError, fieldErrors } = auth;

  return (
    <Stack
      component="form"
      onSubmit={(e) => {
        e.preventDefault();
        auth.handleLogin();
      }}
      spacing={2}
      sx={{ mt: 1, flex: 1 }}
    >
      <Typography variant="body1" fontWeight={500}>
        Войдите в аккаунт
      </Typography>
      <IdentifierField
        otpStrategy={auth.otpStrategy}
        value={form.identifier}
        onChange={auth.handleIdentifierChange}
        onBlur={auth.handleIdentifierBlur}
        error={fieldErrors.identifier}
        placeholder={auth.fieldPlaceholder}
        autoComplete={auth.fieldAutoComplete}
        autoFocus
      />
      <TextField
        fullWidth
        label="Пароль"
        type={ui.showPassword ? 'text' : 'password'}
        value={form.password}
        onChange={(e) => {
          auth.updateForm({ password: e.target.value });
          auth.setSubmitError(null);
        }}
        autoComplete="current-password"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                type="button"
                onClick={() => auth.updateUi({ showPassword: !ui.showPassword })}
                edge="end"
              >
                <Icon icon={ui.showPassword ? 'mdi:eye-off' : 'mdi:eye'} />
              </IconButton>
            </InputAdornment>
          )
        }}
      />
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          type="button"
          sx={{ textTransform: 'none', p: 0, minWidth: 0 }}
          onClick={auth.goToResetSend}
        >
          <Typography variant="body2" color="text.secondary">
            Забыли пароль?
          </Typography>
        </Button>
      </Box>
      <Box sx={{ mt: 'auto !important' }}>
        <SubmitError error={submitError} />
        <Button
          fullWidth
          variant="contained"
          color="primary"
          size="large"
          type="submit"
          disabled={!form.identifier || !form.password || loading}
          sx={{ mt: submitError ? 1 : 0 }}
        >
          {loading ? 'Вход...' : 'Войти'}
        </Button>
        <Divider sx={{ my: 2 }}>или</Divider>
        <YandexLoginButton />
      </Box>
    </Stack>
  );
}
